/**
 * Created by Daniela on 19/10/2016.
 */
import { NgModule }     from '@angular/core';
import { RouterModule } from '@angular/router';

import {PessoaListComponent} from "./pessoa-list/pessoa-list.component";
import {PessoaFormComponent} from "./pessoa-form/pessoa-form.component";
import {editRoute, newRoute} from "../../shared/services/data.service";

@NgModule({
  imports: [
    RouterModule.forChild([])
  ],
  exports: [
    RouterModule
  ]
})
export class PessoasRoutingModule {}

export const pessoasRoutes: any[] = [
  {
    path: '',
    component: PessoaListComponent
  },{
    path: editRoute + '/:id',
    component: PessoaFormComponent
  },{
    path: newRoute,
    component: PessoaFormComponent
  }
];



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/recursos-humanos/pessoas/pessoas-routing.module.ts
 **/